import vertexShader from "../../shaders/vertex.vert";
import fragmentShader from "../../shaders/tower.frag";
import MAD from "../mad-engine";

export default class Tower extends MAD.Entity{
    constructor(){
        super();
        this.color = Math.random() * 30 + 345;
        this.color %= 360;
        const uniforms = {
            u_curve: { type: "float", value: 0 },
            u_progress: { type: "float", value: 0 },
            u_color: { type: "color", value: new THREE.Color(`hsl(${this.color},100%,55%)`) }
        };
        this.material =  new THREE.ShaderMaterial( {
            vertexShader,
            fragmentShader,
            uniforms: uniforms
        });

        this.height = 0;
        this.root.position.y = -30;
        this.root.position.z = Math.random() * - 250;
        this.root.position.x = Math.sign(Math.random() - 0.5) * (20 + Math.random() * 100 ); 
        this.generateFloors();
    }

    update(){
        const { clock } = MAD.App.instance;
        const { noise } = MAD.STORE.data;
        
        this.root.position.z += noise.getSpeed();
        if(this.root.position.z > 10){
            this.root.position.z = -250 - Math.random() * 250;
            this.root.position.x = Math.sign(Math.random() - 0.5) * (20 + Math.random() * 100 ); 
        }
        this.material.uniforms.u_curve.value = noise.getCurve();
        this.material.uniforms.u_progress.value = noise.getProgress();
        this.material.uniforms.needsUpdate = true;
    }

    addFloor(){
        const h = Math.random() * 7 + 5;
        const w1 = Math.random() * 10 + 10
        const w2 = Math.random() * 10 + 10
        const g =  new THREE.BoxGeometry( w1,h,w2);
 
        const floor = new THREE.Mesh( g, this.material );
        floor.position.set(Math.random() * 4 - 2,this.height + h/2,Math.random() * 4 - 2);
       // floor.rotation.y = Math.PI * 2 * Math.random();
        floor.frustumCulled = false;
        this.root.add(floor);
        this.height += h;
    }

    generateFloors(){
        let nb = Math.floor( 5 + Math.random() * 15);
        for(let i = 0;i<nb;i++)
            this.addFloor();
    }
}